import { IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

export default function LockSettingModalHeader({
  showBackButton,
  onBackIconClick,
}) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography
        variant="h6"
        id="transition-modal-title"
        style={{
          color: "#565556",
          fontFamily: "DM Sans",
          fontWeight: 700,
          fontSize: "20px",
          lineHeight: "20px",
        }}
      >
        {!showBackButton ? (
          "Lock Settings"
        ) : (
          <IconButton onClick={onBackIconClick}>
            <ArrowBackIosIcon />
          </IconButton>
        )}
      </Typography>
      {/* <IconButton
                aria-label="close"
                onClick={_handleClose}
                style={{ color: "#123051", width: "16px", height: "16px" }}
              >
                <CloseIcon />
              </IconButton> */}
    </Stack>
  );
}
